import { useContext } from 'react';

import { fetchAuthSession } from 'aws-amplify/auth';

import { UNIFIED } from 'src/app/analytics/analyticsEvents';
import { ClientContext } from 'src/app/client';
import type { SegmentEvent } from 'src/app/types';

import { ViewReceiptAnchor } from './styles';

export const DownloadReceiptButton = (props: { orderId: string; dispatchSegmentTrack: SegmentEvent }) => {
  const client = useContext(ClientContext);

  const getReceiptUrl = async (orderId: string) => {
    // Force  client to  reload credentials  by  waiting on  a  request that  requires auth  and
    // discarding the result.
    await client.bffGetOrderDetail(orderId);

    // WORKAROUND, DO NOT COPY THIS CODE.
    const { accessToken } = (await fetchAuthSession()).tokens ?? {}; // Refreshes the token if the refresh token is still valid.
    const token = accessToken?.toString();

    // TODO: WHY IS THE TOKEN IN QS??????
    return `${process.env.NEXT_PUBLIC_RECEIPTS_AGENT_URL}/v2/order/${orderId}/receipt?token=${token}`;
  };

  return (
    <ViewReceiptAnchor
      // eslint-disable-next-line no-script-url
      href="javascript:void(0);"
      download={`receipt-order-${props.orderId}.pdf`}
      onClick={async () => {
        props.dispatchSegmentTrack(UNIFIED.downloadsAReceipt, null);
        window.open(await getReceiptUrl(props.orderId), '_blank');
      }}
      aria-label={'Opens the receipt in PDF format'}
    >
      View receipt
    </ViewReceiptAnchor>
  );
};
